<h1 class="page-header"><i class="fa fa-pencil-square" aria-hidden="true"></i> CUSTOM FIELDS</h1>
<div class="container-fluid">

	<div class="page-button">
        <a href="#customFields" data-toggle="modal" class="btn btn-primary btn-sm" role="button"><i class="fa fa-plus" aria-hidden="true"></i> CREATE NEW FIELDS</a>
		<span id="userOptionsBar"></span>

		<div class="btn-group edgefinityHeader">
			<button type="button" class="btn btn-primary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			  <i class="fa fa-wrench" aria-hidden="true"></i> ACTIONS <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
			  <li><a (click)="duplicateUserRoles()"><i class="fa fa-clone" aria-hidden="true"></i> DUPLICATE</a></li>
			  <li><a (click)="deleteUserRoleQuery()"><i class="fa fa-times" aria-hidden="true"></i> DELETE</a></li>
			</ul>
		</div>
	</div>

	<div class="modal fade" id="customFields" role="dialog">
			<div class="modal-dialog">
			
			  <!-- Modal content-->
			  <div class="modal-content">
				<div class="modal-header">
				  <button type="button" class="close" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i></button>
				  <h4 class="modal-title"><i class="fa fa-pencil-square" aria-hidden="true"></i> CUSTOM FIELDS</h4>
				</div>
				<div class="modal-body">
                    <div class="checkbox">
                        <input id="reqd" type="checkbox" class="styled" checked>
                        <label for="reqd">Required?</label>
                    </div>

                    <div class="row">
						<div class="col-sm-8">
							<input type="text" class="form-control" id="field" name="field" placeholder="FIELD NAME">
						</div>
						<div class="col-sm-4">
                            <div class="form-group">
                                <select class="form-control" ng-model="inputTypes">
                                    <option value="" disabled selected>Field Type</option>
                                    <option value="inputField">Input Field</option>
                                    <option value="textArea">Textarea</option>
                                    <option value="checkboxes">Checkboxes</option>
                                    <option value="radioButtons">Radio Buttons</option>
                                    <option value="dropdown">Select Drowpdown</option>
                                    <option value="multiSelect">Multi-Select Drowpdown</option>
                                </select>
                            </div>	
                        </div>
                        <div class="col-sm-12" id="options-header">
                            <h6>OPTIONS</h6>
                                <div class="row">
                                    <div class="col-sm-1" id="icon-space">
                                        <i class="fa fa-minus-square fa-lg orange" aria-hidden="true"></i>
                                    </div>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" id="input" placeholder="Option Name">
                                    </div>
                                    <div class="checkbox col-sm-4">
                                            <input id="checkbox5" type="checkbox" class="styled" checked>
                                            <label for="checkbox5">
                                                Pre-Selected?
                                            </label>
                                        </div>
                                </div>
                                
                                <br>
                                <button type="button" class="btn btn-primary btn-xs"><i class="fa fa-plus" aria-hidden="true"></i> Add New Option</button>
                        </div>
					</div>
                        <hr>
                        
                    ASSIGN TO
                    <div class="row">
                        <div class="col-sm-12">
                             <angular2-multiselect [data]="roleDropDownList" [(ngModel)]="roleSelectedItems" [settings]="roleDropDownSettings"
                           (onSelect)="selectRoleItem($event)" (onDeSelect)="deselectRoleItem($event)" (onSelectAll)="selectAllRoleItems()" (onDeSelectAll)="deselectAllRoleItems()"
                            ></angular2-multiselect>
                        </div>
                    </div>    



				</div>
				<div class="modal-footer">
				  <button type="button" class="btn btn-default" data-dismiss="modal"><i class="fa fa-ban" aria-hidden="true"></i> CANCEL</button>
				  <button type="button" class="btn btn-primary" data-dismiss="modal"><i class="fa fa-plus" aria-hidden="true"></i> CREATE</button>
				</div>
			  </div>
			  
			</div>
		  </div>
	
	<div class="table-responsive" id="userTableHolder">
		<table class="table tablesorter tablesorter-default table-hover" id="table1">
			<thead>
				<tr>
                    <th style="width: 10px"><div class="checkbox checkbox-inline"><input type="checkbox" id="selectAll" /><label for="inlineCheckbox1"></label></div></th>
                    <th>FIELD NAME</th>
                    <th>FIELD TYPE</th>
					<th>ASSIGNED TO</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let userTag of mUserAndTags">
					<tr (click)="editUser(userTag.user, userTag.tag)">
						<!-- Profile Image -->
						<td><img [src]="getPathForUserImage(userTag)" width="80" height="80" alt="{{userTag.user.firstName}}" /></td>
						
						<!-- User ID -->
						<td>{{userTag.user.login}}</td>
						
						<!-- Name -->
						<td>{{userTag.user.firstName}}&nbsp;{{userTag.user.lastName}}</td>
						
						<!-- Email -->
						<td>{{userTag.user.email}}</td>
						
						<!-- Mobile -->
						<td *ngIf="userTag.user.cellNumber != null && userTag.user.cellNumber.length > 0">{{userTag.user.cellNumber}}</td>
						<td *ngIf="userTag.user.cellNumber == null || userTag.user.cellNumber.length === 0">N/A</td>
						
						<!-- Tag -->
						<td *ngIf="userTag.tag !== null">{{userTag.tag.name}}</td>
						<td *ngIf="userTag.tag === null">N/A</td>
						
						<!-- Role Type -->
						<td>
							<ng-container *ngIf="userTag.user.groups != null && userTag.user.groups.length > 0">
								<ng-container *ngFor="let group of userTag.user.groups">
									{{group.name}}<br/>
								</ng-container>
							</ng-container>
            			</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
</div>